var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 678,
    viewBox: "0 0 533 678",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 533,
    height: 678,
    fill: "url(#paint0_linear_1823_22691)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1823_22691",
    x1: 0,
    y1: 0,
    x2: 959.253,
    y2: 970.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EA4335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBackground);
export default __webpack_public_path__ + "static/media/Gradient-Background.2ea0c7068e0b310a7d36551b3167f8cd.svg";
export { ForwardRef as ReactComponent };